import { krdetailConstants } from '../constants/krdetails.constants';
import i18next from 'i18next';
const OrgChartViz = (() => {
  const MARGIN = {
    top: 30, // TODO: Also affects relative node vs link positions...
    top_only: 10, // ...So use this for now for pure top margin adjustments.
    right: 20,
    bottom: 20,
    left: 20,
  };
  const ARROW_WIDTH = 24, ARROW_HEIGHT = 24;
  let _root = {};
  let _nodes = [];
  let _counter = 0;
  let _svgroot = null;
  let _svg = null;
  let _tree = null;
  let _diagonal = null;
  let _lineFunction = null;
  let _loadFunction = null;
  let par;
  let opts = {};
  let timeout = 800;
  let width = 1000;
  let height = 500;
  /* Configuration */
  /* Duration of the animations */
  const _duration = 750;
  /* Width of the rectangle */
  const _rectW = 300;
  /* Height of the rectangle */
  const _rectH = 125;
  /* Spacing between the rectangles */
  const _rectSpacing = 20;
  /* Height of the line for child nodes */
  let _fixedDepth = 80;
  /* Choose the values "line" or "diagonal" */
  let _mode = 'line';
  let _callerNode = null;
  const _callerMode = 0;
  const _boxColors = ['rgba(127, 210, 225, 0.1)', 'rgba(204, 204, 204, 0.1)', 'rgba(179, 157, 218, 0.1)', 'rgba(234, 162, 65, 0.1)'];
  const _boxBorderColors = ['#52bad5', '#cccccc', '#b39dda', '#eaa241'];
  const mouseduration = 500;
  let _tooltipDiv = null;
  let rootParentId = null;
  let upWard = false;
  let pingPermission = false;
  let currentUserId = '';
  let expandFull = false;
  let cascade = false;
  let openKRPage = null;
  let setVizStyles = null;
  let metricType = null;

  function boxColor(index) {
    const i = (index % 4);
    return _boxColors[i] || _boxColors[0];
  }

  function boxBorderColor(index) {
    const i = (index % 4);
    return _boxBorderColors[i] || _boxBorderColors[0];
  }

  function defLinearGradient(id, x1, y1, x2, y2, stopsdata) {
    const gradient = _svgroot.append('svg:defs')
      .append('svg:linearGradient')
      .attr('id', id)
      .attr('x1', x1)
      .attr('y1', y1)
      .attr('x2', x2)
      .attr('y2', y2)
      .attr('spreadMethod', 'pad');

    $.each(stopsdata, (index, value) => {
      gradient.append('svg:stop')
        .attr('offset', value.offset)
        .attr('stop-color', value.color)
        .attr('stop-opacity', value.opacity);
    });
  }

  function defBoxShadow(id) {
    const filter = _svgroot.append('svg:defs')
      .append('svg:filter')
      .attr('id', id).attr('height', '150%')
      .attr('width', '150%');

    filter.append('svg:feOffset')
      .attr('dx', '2').attr('dy', '2').attr('result', 'offOut'); // how much to offset
    filter.append('svg:feGaussianBlur')
      .attr('in', 'offOut').attr('result', 'blurOut').attr('stdDeviation', '2'); // stdDeviation is how much to blur
    filter.append('svg:feBlend')
      .attr('in', 'SourceGraphic').attr('in2', 'blurOut').attr('mode', 'normal');
  }

  function collapse(d) {
    if (d.children) {
      d.children.forEach(function (d1) {
        if (d1.children) {
          d1.parentId = d.id;
          collapse(d1);
          d1._children = d1.children;
          d1.children = null;
        }
      });
    }
  }

  function getTooltipText(d, className) {
    let tooltipText = '';
    switch (className) {
      case 'headerText':
        if (d.tooltipHeader) {
          let teamName = d.teamName ? d.teamName : '';
          let ownerName = d.ownerName ? ` ${d.ownerName}` : '';
          if (cascade) {
            if (d.up == false && d.level == 0) {
              tooltipText = ownerName + (d.teamName ? ' · '  + teamName : '');
            } else {
              tooltipText = ownerName;
            }
          } else {
            tooltipText = ownerName + (d.teamName ? ' · ' + teamName : '');
          }
        }
        break;
      case 'nameText':
        tooltipText = d.name;
        break;
      case 'footerText':
        if (d.tooltipFooter) {
          tooltipText =
            (d.pending ? '' : d.achieveText) +
            (d.targetDisplay && !d.pending ? ` of ${d.targetText.toString()}` : '') +
            (d.sourceText ? ' · Source: ' + d.sourceText : '');
        }
        break;
      default:
        console.warn('getTooltipText: Unknown class');
        break;
    }
    return tooltipText;
  }

  function mouseOver(d) {
    let tooltipText = getTooltipText(d, d3.select(this).attr('class'));
    if (!tooltipText || !tooltipText.trim().length) return;
    _tooltipDiv.interrupt();
    _tooltipDiv
      .style('display', 'inline')
      .style('left', 0 + 'px')
      .style('top', 0 + 'px');
    let rectTT = _tooltipDiv.node().getBoundingClientRect(),
        xPos = (d3.event.clientX - rectTT.left) + 18,
        yPos = (d3.event.clientY - rectTT.top) + 12;
    _tooltipDiv
      .html(tooltipText)
      .style('left', xPos + 'px')
      .style('top', yPos + 'px');
    _tooltipDiv.transition()
      .duration(mouseduration)
      .style('opacity', 0.9);
  }

  function mouseOut() {
    _tooltipDiv.transition()
      .duration(mouseduration)
      .style('opacity', 1e-6)
      .style('display', 'none');
  }

  function wrap(text, width, maxLine = 1) {
    text.each(function wrapText() {
      let text = d3.select(this);
      const words = text.text().split(/\s+/).reverse();
      let word = words.pop();
      let line = [];
      let lineNumber = 0;
      const lineHeight = 1.1; // ems
      const x = text.attr('x');
      const y = text.attr('y');
      const dy = 1.1;
      let lineCount = 1;
      let maxLength = 40;
      let tspan = text.text(null)
        .append('tspan')
        .attr('class', `line-${lineCount}`)
        .attr('x', x)
        .attr('y', y)
        .attr('dy', `${dy}em`);

      while (word) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
          lineCount += 1;
          line.pop();
          tspan.text(line.join(' '));

          let lengthyWord = [];
          if ((word.length) > maxLength) {
            let len = (word.length) / maxLength;

            for (let i = 0; i < len; i++) {
              let wrd = word.slice(i * maxLength == 1 ? 0 : i * maxLength, (i + 1) * maxLength);
              lengthyWord.push(wrd);
            }
            let fLength = lengthyWord.length;
            words.pop();
            for (let j = 0; j < fLength; j++) {
              words.push(lengthyWord.pop());
            }
            word = words.pop();
          }

          line = [word];
          tspan = text.append('tspan')
            .attr('x', x)
            .attr('y', y)
            .attr('class', `line-${lineCount}`)
            .attr('dy', `${++lineNumber * lineHeight + dy}em`)
            .text(word);
        }
        word = words.pop();
      }
      const tspanObject = text.selectAll('tspan');
      if (Array.isArray(tspanObject[0])) {
        let tspanCount = tspanObject[0].length;
        if (tspanCount > maxLine) {
          while (tspanCount > maxLine) {
            text.select(`tspan.line-${tspanCount}`).remove();
            tspanCount -= 1;
          }
          text.append('tspan').attr('class', 'elip').text('...');
          text.attr('tooltip', true)
            .on('mouseover', mouseOver)
            .on('mouseout', mouseOut);
        }
      }
    });
  }

  function elipse(text, reqWidth) {
    text.each(function elipseText() {
      let text = d3.select(this);
      const words = text.text().split(/\s+/);
      const originalText = text.text();
      const ellipsis = text.text('').append('tspan').attr('class', 'elip').text('...');
      const width = reqWidth || parseFloat(text.attr('width')) - ellipsis.node().getComputedTextLength();
      const numWords = words.length;
      const tspan = text.insert('tspan', ':first-child').text(words.join(' '));
      // Try the whole line
      // While it's too long, and we have words left, keep removing words
      while (tspan.node().getComputedTextLength() > width && words.length) {
        words.pop();
        tspan.text(words.join(' '));
      }
      if (words.length === numWords) {
        ellipsis.remove();
      } else {
        text.attr('tooltip', true)
          .on('mouseout', mouseOver)
          .on('mouseout', mouseOut);
      }
    });
  }

  function concateRootSourceName(d) {
    let sourceText = d.sourceText;
    return sourceText;
  }

  function hasGivePing(d) {
    const permission = (pingPermission || currentUserId == d.uid);
    return (d.pending && permission && currentUserId != d.req_uid);
  }

  function toggleNodes(d) {
    if (d.children) {
      d._children = d.children;
      d.children = null;
    } else {
      d.children = d._children;
      d._children = null;
    }
    if (upWard && !cascade) {
      updateTop(d);
    } else {
      update(d);
    }
  }

  function renderParent(d, top = false) {
    var params = {};
    if (d.up > 0) {
      params.metricId = cascade ? d.up : d.id;
      if (cascade) {
        d.up = 0;
      }
      showLoaderWidget($("#content"));
      let url = '';
      if (top && cascade == false) {
        url = '?up=1';
      }
      $.ajax({
        url: wbConfig.baseUrl + "/goal/viewCascadeTree" + url,
        data: params,
        type: "GET"
      }).done(function (response) {
        removeLoaderWidget();
        _root = response.data;
        if (_root.children) {
          _root.children.forEach(collapse);
          _root.children.forEach(function (d1) {
            if (d1.id == d.id) {
              d1.children = d.children;
              d1._children = d._children;
            }
          });
        }
        if (cascade) {
          update(_root);
        } else {
          if (top) {
            opts.rootParentId = d.id;
            opts.data = _root;
            opts.upWard = true;
            initTree(opts);
            /*
            rootParentId = _root.id;
            updateTop(_root)*/
          } else {
            //rootParentId = par.id;
            opts.rootParentId = d.id;
            opts.data = _root;
            opts.upWard = false;
            initTree(opts);
            //update(_root)
          }
        }
      });
    }
  }

  function update(source, rootUpdate = false) {
    if (rootUpdate) {
      _nodes = _tree.nodes(source).reverse();
    } else {
      _nodes = _tree.nodes(_root).reverse();
    }
    // Compute the new tree layout.
    const links = _tree.links(_nodes);
    // Normalize for fixed-depth.
    _nodes.forEach((d) => {
      d.y = d.depth * _fixedDepth;
    });

    // Update the nodes
    const node = _svg.selectAll('g.node')
      .data(_nodes, d => (`${d.id}-${d.depth}-${d.parentId}` || (d.id = ++_counter)));

    if (!source.x0) {
      source.x0 = 0;
    }

    if (!source.y0) {
      source.y0 = height / 2;
    }

    // Enter any new nodes at the parent's previous position.
    const nodeEnter = node.enter().append('g')
      .attr('class', d => (d.pending ? ' node pending ' : 'node'))
      .attr('transform', d => `translate(${source.x0},${source.y0})`)
      .attr('dx', d => d.x)
      .attr('cursor', d => d.canView && !d.deletedStatus && (typeof d.isExcluded != 'undefined' && !d.isExcluded) ? 'pointer' : 'default')
      .on('click',  nodeclick);

    nodeEnter.append('rect')
      .attr("width", d => {
        //return d.id == rootParentId ? (_rectW + 40) : _rectW
        return _rectW
      })
      .attr('height', d => d.isExcluded ? _rectH +25 : _rectH)
      .attr('id', d => d.id)
      .attr('fill', d => d.id == rootParentId ? boxColor(0) : boxColor(1))
      .attr('stroke', d => d.id == rootParentId ? boxBorderColor(0) : boxBorderColor(1))
      .attr('cursor', d => d.canView && !d.deletedStatus && !d.isExcluded ? 'pointer' : 'default')
      .attr('rx', 4)
      .style({
        strokeWidth: 1,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)'
      })
      .attr('class', 'cascade-box-rect');

    nodeEnter
      .append('image')
      .attr("width", 24)
      .attr("height", 24)
      .attr("x", 10)
      .attr("y", 12)
      .attr('xlink:href', d => (d.deletedStatus ?"": d.picture))
      .attr('clip-path', 'url(#avatar)');

    const headerText = nodeEnter.append('text')
      .attr('class',d=> (d.deletedStatus ? 'hide' :'headerText'))
      .attr('dy', '.45em')//d => (d.pending ? ' node pending ' : 'node')
      .attr('x', 45)
      .attr('y', 25)
      .attr('text-anchor', 'left')
      .attr('width', 249)
      .attr('height', 14)
      .attr('font-size', 12)
      .attr('font-weight', 'normal')
      .attr('letter-spacing', 0.09)
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .on('mouseover', mouseOver)
      .on('mouseout', mouseOut);

    headerText.append('tspan')
      .attr('class', 'headerText')
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .attr('font-size', 12)
      .style('fontSize', '18px')
      .style('fontWeight', 'bold')
      .attr('width', 249)
      .text(d => {
        let teamName = d.teamName ? d.teamName : '';
        let ownerName = d.ownerName ? ` ${d.ownerName}` : '';
        let header = '';
        if (cascade) {
          if (d.up == false && d.level == 0) {
            header = ownerName + (d.teamName ? ' · ' : '') + teamName;
          } else {
            //header = teamName + (d.teamName ? ':' : '') + ownerName;
            header = ownerName;
          }
        } else {
          header = ownerName + (d.teamName ? ' · ' : '') + teamName;
        }

        // let finalHeader = d.id !== rootParentId ? header.slice(0, 40).split('') : header.slice(0, 45).split('');
        // if ((d.id !== rootParentId && header.length > 40) || header.length > 45) {
        //   finalHeader.push('...');
        // }
        // return finalHeader.join('');
        let finalHeader = header.slice(0, 40).split('');
        if (header.length > 40) {
          finalHeader.push('...');
          d.tooltipHeader = true;
        }
        return finalHeader.join('');
      });

    const nameText = nodeEnter.append('text')
      .attr('class', 'nameText')
      .attr('fill', d => d.canView ? 'rgba(0, 0, 0, 0.84)' : 'rgba(0, 0, 0, 0.54)')
      .attr('font-style', d => d.canView ? 'normal' : 'italic')
      .attr('font-size', 14)
      .attr('x',  14)
      .attr('y',  42)
      .attr('text-anchor', 'left')
      .attr('width', _rectW - 50)
      // .text(d => d.name.trim())
      .text(d => {
        if(d.deletedStatus) return "The source key result has been removed, please edit this key result to update the source"
       else return (d.name || '').trim()})
      .call(wrap, 270, 3);

    const footerText = nodeEnter.append('text')
      .attr('class',d=> (d.deletedStatus ? 'hide' :'footerText'))
      .attr('x', 14)
      .attr('y', 112)
      .attr('text-anchor', 'left')
      .attr('width', 249)
      .attr('height', 14)
      .attr('height', 14)
      .attr('height', 14)
      .attr('font-weight', 'normal')
      .attr('letter-spacing', 0.09)
      .on('mouseover', mouseOver)
      .on('mouseout', mouseOut);

    footerText.append('tspan')
      .attr('class', 'footerText')
      .attr('letter-spacing', 0.11)
      .attr('fill', d => d.metricColor)
      .attr('font-size', 14)
      .text(d => d.pending ? '' : d.achieveText)
      .append('tspan')
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .attr('font-size', 12)
      .append('tspan')
      .text(d => d.targetDisplay && !d.pending ? ` of ${d.targetText.toString()}` : '')
      .append('tspan')
      .text(d => d.sourceText ? ` · Source: ` : '')
      .append('tspan')
      .attr('fill', 'rgba(0, 0, 0, 0.84')
      .text(d => {
        let res = `${d.sourceText}`;
        let targetTextLength = 0;
        if (d.targetDisplay && !d.pending) {
          targetTextLength = d.targetText.toString().length + 4
        }
        let textLength = targetTextLength + (d.achieveText.toString().length);
        if (textLength > 22) {
          textLength = 22;
        }
        let n = textLength > 12 ? 2 : 0;
        // let finalText = d.id != rootParentId ? res.slice(0, (39 - n - textLength)).split('') : res.slice(0, (45 - n - textLength)).split('');
        // if ((d.id != rootParentId && res.length > (39 - n - textLength)) || res.length > (45 - n - textLength)) {
        //   finalText.push('...');
        // }
        // return finalText.join('');
        let finalText = res.slice(0, (39 - n - textLength)).split('');
        if (res.length > (39 - n - textLength)) {
          finalText.push('...');
          d.tooltipFooter = true;
        }
        return finalText.join('');
      });

      const excludedText = nodeEnter.append('text')
      .attr('class', d=> (!d.isExcluded ? 'hide' :'footerText'))
      .attr('x', 14)
      .attr('y', 130)
      .attr('text-anchor', 'left')
      .attr('width', 249)
      .attr('height', 14)
      .attr('height', 14)
      .attr('height', 14)
      .append('tspan')
      .attr('fill', 'rgba(0,0,0,.54)')
      .attr('font-size', 10)
      .style('float','left')
      .text('*The source key result has been excluded.')

      const excludedText2 = nodeEnter.append('text')
      .attr('class', d=> (!d.isExcluded ? 'hide' :'footerText'))
      .attr('x', 20)
      .attr('y', 142)
      .attr('text-anchor', 'left')
      .attr('width', 249)
      .attr('height', 14)
      .append('tspan')
      .attr('fill', 'rgba(0,0,0,.54)')
      .attr('font-size', 10)
      .style('float','left')
      .text('Please edit the key result to update the source.')

    const ownerText = nodeEnter.append('text')
      .attr('class',d=> (d.deletedStatus ? 'hide' :'ownerText'))
      .attr('x', 14)
      .attr('y', 90)
      .attr('dy', '.45em')
      .attr('text-anchor', 'left');
    ownerText.append('tspan')
      .attr('font-size', 12)
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .text(d => d.pending ? 'Owner: ' : '');

    ownerText.append('tspan')
      .attr('font-size', 12)
      .text(d => d.pending ? d.ownerName : '')
      .attr('width', d => (hasGivePing(d) ? _rectW - 90 : _rectW - 50))
      .call(elipse, 200);

    ownerText.append('tspan')
      .attr('class', 'dotclass ping-label-dotclass ')
      .text(d => (hasGivePing(d) ? '  ·  ' : ''))
      .append('tspan')
      .attr('class', 'ping-label')
      .text(d => (hasGivePing(d) ? 'Ping' : ''))
      .on('click', pingMetric);

    const downimages = nodeEnter.append('image')
      .attr('xlink:href', function () {
        return wbConfig.baseUrl + '/images/icons/down_blue_arrow.png';
      })
      .attr('x', function () {
        let bbNode = this.parentElement.getBBox();
        return bbNode.width / 2 - ARROW_WIDTH / 2;
      })
      .attr('y', function () {
        let bbNode = this.parentElement.getBBox();
        return bbNode.height + 5;
      })
      .attr('height', d => d._children || d._down ? ARROW_HEIGHT : 0)
      .attr('width', d => (d.down || d._down ? ARROW_WIDTH : 0))
      .attr('cursor', 'pointer');

    // make the image grow a little on mouse over and add the text details on click
    const setEvents = downimages
      // Append hero text
      .on('click', function (d) {
        if (d.id != rootParentId || cascade) {
          toggleNodes(d);
          update(d);
        } else {
          let rId = document.getElementById(d.id);
          if (rId.id == rootParentId) {
            rId.style.width = _rectW //_rectW + 40;
          }
          if (d.down) {
            renderParent(d);
            d.upWard = false;
          }
        }
        $(this).attr('height', 0);
        d3.event.stopPropagation();
        return false;
      });

    const upimages = nodeEnter.append('image')
      .attr('xlink:href', function (d) {
        if (!d.down && d.id == rootParentId) {
          return renderParent(d, !cascade);
        }
        return wbConfig.baseUrl + '/images/icons/up_blue_arrow.png';
      })
      .attr('x', function () {
        let bbNode = this.parentElement.getBBox();
        return bbNode.width / 2 - ARROW_WIDTH / 2;
      })
      .attr('y', -(ARROW_HEIGHT + 1))
      .attr('height', d => (d.up ? ARROW_HEIGHT : 0))
      .attr('width', d => (d.up ? ARROW_WIDTH : 0))
      .attr('cursor', 'pointer');

    // make the image grow a little on mouse over and add the text details on click
    const setEvents1 = upimages
      // Append hero text
      .on('click', function (d) {
        console.log("image clicked " + d.up);
        $(this).attr('height', 0);
        if (cascade) {
          if (d.up) {
            renderParent(d);
          }
        } else {
          if (d.id != rootParentId) {
            toggleNodes(d);
            update(d);
          } else {
            let rId = document.getElementById(d.id);
            if (rId.id == rootParentId) {
              rId.style.width = _rectW //_rectW + 40;
            }
            if (d.up) {
              d.upWard = true;
              renderParent(d, true);
            }
          }
        }
        d3.event.stopPropagation();
        return false;
      })

    // Transition nodes to their new position.
    const nodeUpdate = node.transition()
      .duration(_duration)
      .attr('transform', d => `translate(${d.x},${d.y})`);

    // Transition exiting nodes to the parent's new position.
    const nodeExit = node.exit().transition()
      .duration(_duration)
      .attr('transform', d => `translate(${source.x},${source.y})`)
      .remove();

    // Update the links
    const link = _svg.selectAll('path.link')
      .data(links, d => `${d.target.id}-${d.target.depth}-${d.target.parentId}`);

    if (_mode === 'line') {
      // Enter any new links at the parent's previous position.
      link.enter().append('path', 'g')
        .attr('class', 'link')
        .attr('d', (d) => {
          const o = {
            x: source.x0,
            y: source.y0,
          };
          return _diagonal({
            source: o,
            target: o,
          });
        })
        .attr('stroke', d => d.source.id == rootParentId ? boxBorderColor(0) : boxBorderColor(1))
        .style('stroke-width', 1)
        .style('opacity', 1e-6);

      link
        .transition()
        .duration(_duration) // Was _duration * 2, but links should always transition together with the nodes.
        .style('opacity', 1)
        .attr('d', (d) => {
          const u_line = (function (d) {
            const u_linedata = [{
              x: d.source.x + parseInt(_rectW / 2),
              y: d.source.y + _rectH
            },
            {
              x: d.source.x + parseInt(_rectW / 2),
              y: d.target.y - MARGIN.top / 2
            },
            {
              x: d.target.x + parseInt(_rectW / 2),
              y: d.target.y - MARGIN.top / 2
            },
            {
              x: d.target.x + parseInt(_rectW / 2),
              y: d.target.y
            }
            ];
            return u_linedata;
          }(d));

          return _lineFunction(u_line);
        });

      // Transition exiting nodes to the parent's new position.
      link.exit().transition()
        .duration(_duration)
        .style('opacity', 1e-6)
        .attr('d', (d) => {
          /* This is needed to draw the lines right back to the caller */
          const u_line = (function () {
            const u_linedata = [{
                x: _callerNode.x + parseInt(_rectW / 2),
                y: _callerNode.y + _rectH + 2
              },
              {
                x: _callerNode.x + parseInt(_rectW / 2),
                y: _callerNode.y + _rectH + 2
              },
              {
                x: _callerNode.x + parseInt(_rectW / 2),
                y: _callerNode.y + _rectH + 2
              },
              {
                x: _callerNode.x + parseInt(_rectW / 2),
                y: _callerNode.y + _rectH + 2
              }
            ];
            return u_linedata;
          }(d));

          return _lineFunction(u_line);
        })
        .each('end', () => {
          _callerNode = null; /* After transition clear the caller node variable */
        });
    } else if (_mode === 'diagonal') {
      // Enter any new links at the parent's previous position.
      link.enter().insert('path', 'g')
        .attr('class', 'link')
        .attr('x', _rectW / 2)
        .attr('y', _rectH / 2)
        .attr('d', (d) => {
          const o = {
            x: source.x0,
            y: source.y0,
          };
          return _diagonal({
            source: o,
            target: o,
          });
        })
        .style('opacity', 1e-6);

      // Transition links to their new position.
      link.transition()
        .duration(_duration) // Was _duration * 2, but links should always transition together with the nodes.
        .style('opacity', 1)
        .attr('d', _diagonal);

      // Transition exiting nodes to the parent's new position.
      link.exit().transition()
        .duration(_duration)
        .style('opacity', 1e-6)
        .attr('d', (d) => {
          const o = {
            x: source.x,
            y: source.y,
          };
          return _diagonal({
            source: o,
            target: o,
          });
        })
        .remove();
    }

    // Stash the old positions for transition.
    _nodes.forEach((d) => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
  }

  // Toggle children on click.
  function nodeclick(d) {
    if (d.pending || (typeof d.isExcluded != 'undefined' && d.isExcluded)) {
      return false;
    }
    if(d.deletedStatus) return false;
    if (!d.canView) {
      return false;
    }
    if (!cascade) {
      height = 500;
    }
    if (d3.event.defaultPrevented) {
      return;
    } else {
      if (typeof openKRPage === 'function') {
        setVizStyles(false);
        openKRPage({
          id: d.id,
          source: 'krDataFlow'
        });
      } else {
        setVizStyles(false);
        krDetailPage(d.id, 'krDataFlow', true);
      }
    }
  }

  function pingMetric(d) {
    if (hasGivePing(d)) {
      $.post(wbConfig.baseUrl + '/goal/sendCascdePingNotification', {
        metricId: d.metric_id,
        reqUserID: d.req_uid
      }, function (response) {
        if (response.status) {
          if (infoPopup) {
            if ($('.infoPopup').length) {
              $('.infoPopup').css("z-index", 5000001);
            }
            infoPopup.call(d.ownerName + ' '+i18next.t('will get a notification and an email asking for an update'));
          }
        }
      });
    }
  }

  function initTree(options) {
    opts = options;
    const u_opts = Object.assign({
      id: '',
      data: {},
      modus: 'line',
      width: '',
      height: '',
      loadFunc() { }
    }, options);
    const id = u_opts.id;
    rootParentId = u_opts.rootParentId || null;
    pingPermission = u_opts.pingPermission || false;
    upWard = u_opts.upWard || false;
    currentUserId = u_opts.currentUserId || '';
    expandFull = u_opts.expandFull || false;
    cascade = u_opts.cascade || false;
    openKRPage = u_opts.openKRPage || null;
    setVizStyles = u_opts.setVizStyles || null;
    metricType = u_opts.metricType || null;
    _loadFunction = u_opts.loadFunc;
    _mode = u_opts.modus;
    _root = u_opts.data;

    if (metricType && metricType == krdetailConstants.TYPE_CASCADE) {
      MARGIN.top_only = 40;
    }

    if (_mode == 'line') {
      _fixedDepth = _rectH + 30;
    } else {
      _fixedDepth = 110;
    }

    $(id).html(''); // Reset
    if (width === '') {
      width = $(id).innerWidth();
    }
    if (height === '') {
      height = $(id).innerHeight();
    }
    height = height < 0 ? 800 : height;
    _tree = d3.layout.tree().nodeSize([_rectW + _rectSpacing, _rectH + _rectSpacing]);

    /* Basic Setup for the diagonal function. _mode = "diagonal" */
    _diagonal = d3.svg.diagonal()
      .projection(d => [d.x + _rectW / 2, d.y + _rectH / 2]);

    /* Basic setup for the line function. _mode = "line" */
    _lineFunction = d3.svg.line()
      .x(d => d.x)
      .y(d => d.y)
      .interpolate('linear');

    const u_childwidth = (typeof _root.children !== 'undefined') ? parseInt((_root.children.length * _rectW) / 2) : 0;

    var zm = null;
    _svgroot = d3.select(id)
      .append('svg')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('class', 'cascade-visualization-svg')
      .attr('cursor', 'grab')
      .call(zm = d3.behavior.zoom().scaleExtent([0.1, 3])
        .on('zoom', function () {
          _svg.attr('transform', `translate(${d3.event.translate}) scale(${d3.event.scale})`);
        })
      );

    // Necessary so that zoom knows where to zoom and unzoom from
    zm.translate([parseInt(u_childwidth + ((width - u_childwidth * 2) / 2)), MARGIN.top + MARGIN.top_only]);

    _tooltipDiv = d3.select(id).append('div')
      .attr('class', 'svg-tooltip')
      .style('opacity', 0)
      .style('display', 'none');

    _svg = _svgroot.append('g')
      .attr('class', 'viewtree-parent')
      .attr('data-testid','view-data-flow-tree')
      .attr('transform', `translate(${parseInt(u_childwidth + ((width - u_childwidth * 2) / 2))},${MARGIN.top + MARGIN.top_only})`);

    var u_stops = [{
      offset: '0%',
      color: '#03A9F4',
      opacity: 1
    }, {
      offset: '100%',
      color: '#0288D1',
      opacity: 1
    }];
    defLinearGradient('gradientnochilds', '0%', '0%', '0%', '100%', u_stops);
    var u_stops = [{
      offset: '0%',
      color: '#8BC34A',
      opacity: 1
    }, {
      offset: '100%',
      color: '#689F38',
      opacity: 1
    }];
    defLinearGradient('gradientchilds', '0%', '0%', '0%', '100%', u_stops);

    defBoxShadow('boxShadow');

    let defs = _svg.append("defs").attr("id", "imgdefs");
    let avatar = defs.append("clipPath")
      .attr("id", "avatar")
      .append("circle")
      .attr("cx", 22)
      .attr("cy", 24)
      .attr('r', 12)
      .attr('fill', '#ffffff');

    _root.x0 = 0; // the root is already centered
    _root.y0 = height / 2; // draw & animate from center
    if (typeof _root.children !== 'undefined' && !expandFull) {
      _root.children.forEach(collapse);
    }
    par = _root;
    if (upWard && !cascade) {
      updateTop(_root);
    } else {
      update(_root);
    }
    let gNodeXvalues = [];
    d3.selectAll('g.node').each(function iterateEach(d) {
      gNodeXvalues = gNodeXvalues.concat(d3.select(this).attr('dx'));
    });
    if (gNodeXvalues.length) {
      let minX = Math.min(...gNodeXvalues);
      if (minX < -320) {
        let x = -minX + 10, y = MARGIN.top;
        d3.select('svg g').attr('transform', `translate(${x}, ${y})`);
        zm.translate([x, y]);
      }
    }
  }

  function updateTop(source, rootUpdate = false) {
    // Compute the new tree layout.
    if (rootUpdate) {
      _nodes = _tree.nodes(source).reverse();
    } else {
      _nodes = _tree.nodes(_root).reverse();
    }
    const links = _tree.links(_nodes);

    // Normalize for fixed-depth.
    _nodes.forEach((d) => {
      d.y = d.depth * _fixedDepth;
    });

    // Update the nodes
    const node = _svg.selectAll('g.node')
      .data(_nodes, d => (`${d.id}-${d.depth}-${d.parentId}` || (d.id = ++_counter)));

    if (!source.x0) {
      source.x0 = 0;
    }

    if (!source.y0) {
      source.y0 = height / 2;
    }

    // Enter any new nodes at the parent's previous position.
    const nodeEnter = node.enter().append('g')
      .attr('class', d => (d.pending ? ' node pending ' : 'node'))
      .attr('transform', d => `translate(${source.x0},${source.y0})`)
      .attr('dx', d => d.x)
      .attr('cursor', d => d.canView ? 'pointer' : 'grab')
      .on('click', nodeclick);

    nodeEnter.append('rect')
      .attr("width", d => {
        //  return d.id == rootParentId ? (_rectW + 40) : _rectW
        return _rectW
      })
      .attr('height', _rectH)
      .attr('id', d => d.id)
      .attr('fill', d => d.id == rootParentId ? boxColor(0) : boxColor(1))
      .attr('stroke', d => d.id == rootParentId ? boxBorderColor(0) : boxBorderColor(1))
      .attr('rx', 4)
      .style({
        strokeWidth: 1,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)'
      })
      .attr('class', 'cascade-box-rect');

    nodeEnter
      .append('image')
      .attr("width", 24)
      .attr("height", 24)
      .attr("x", 10)
      .attr("y", 12)
      .attr('xlink:href', d => (d.deletedStatus ?"": d.picture))
      .attr('clip-path', 'url(#avatar)');

    const headerText = nodeEnter.append('text')
      .attr('class', d=> (d.deletedStatus ? 'hide' :'headerText'))
      .attr('dy', '.45em')
      .attr('x', 45)
      .attr('y', 25)
      .attr('text-anchor', 'left')
      .attr('width', 249)
      .attr('height', 14)
      .attr('font-size', 12)
      .attr('font-weight', 'normal')
      .attr('letter-spacing', 0.09)
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .on('mouseover', mouseOver)
      .on('mouseout', mouseOut);

    headerText.append('tspan')
      .attr('class', 'headerText')
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .attr('font-size', 12)
      .style({
        fontSize: '18px',
        fontWeight: 'bold'
      })
      .attr('width', 249)
      .text(d => {
        let teamName = d.teamName ? d.teamName : '';
        let ownerName = d.ownerName ? ` ${d.ownerName}` : '';
        let header = ownerName + (d.teamName ? ' · ' : '') + teamName;
        // let finalHeader = d.id !== rootParentId ? header.slice(0, 40).split('') : header.slice(0, 45).split('');
        // if ((d.id !== rootParentId && header.length > 40) || header.length > 45) {
        //   finalHeader.push('...');
        // }
        // return finalHeader.join('');
        let finalHeader = header.slice(0, 40).split('');
        if (header.length > 40) {
          finalHeader.push('...');
          d.tooltipHeader = true;
        }
        return finalHeader.join('');
      });

    const nameText = nodeEnter.append('text')
      .attr('class', 'nameText')
      .attr('fill', d => d.canView ? 'rgba(0, 0, 0, 0.84)' : 'rgba(0, 0, 0, 0.54)')
      .attr('font-style', d => d.canView ? 'normal' : 'italic')
      .attr('font-size', 14)
      .attr('x', 14)
      .attr('y', 42)
      .attr('text-anchor', 'left')
      .attr('width', _rectW - 50)
      .text(d => {
        if(d.deletedStatus) return "The source key result has been removed, please edit this key result to update the source"
       else return (d.name || '').trim()})
      .call(wrap, 270, 3);

    const footerText = nodeEnter.append('text')
      .attr('class',d=> (d.deletedStatus ? 'hide' :'footerText'))
      .attr('x', 14)
      .attr('y', 112)
      .attr('text-anchor', 'left')
      .attr('width', 249)
      .attr('height', 14)
      .attr('height', 14)
      .attr('height', 14)
      .attr('font-weight', 'normal')
      .attr('letter-spacing', 0.09)
      .on('mouseover', mouseOver)
      .on('mouseout', mouseOut);

    footerText.append('tspan')
      .attr('class', 'footerText')
      .attr('letter-spacing', 0.11)
      .attr('fill', d => d.metricColor)
      .attr('font-size', 14)
      .text(d => d.pending ? '' : d.achieveText)
      .append('tspan')
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .attr('font-size', 12)
      .append('tspan')
      .text(d => d.targetDisplay && !d.pending ? ` of ${d.targetText.toString()}` : '')
      .append('tspan')
      .text(d => d.sourceText ? ` · Source: ` : '')
      .append('tspan')
      .attr('fill', 'rgba(0, 0, 0, 0.84')
      .text(d => {
        let res = `${d.sourceText}`;
        let targetTextLength = 0;
        if (d.targetDisplay && !d.pending) {
          targetTextLength = d.targetText.toString().length + 4
        }
        let textLength = targetTextLength + (d.achieveText.toString().length);
        if (textLength > 22) {
          textLength = 22;
        }
        let n = textLength > 12 ? 2 : 0;
        // let finalText = d.id != rootParentId ? res.slice(0, (39 - n - textLength)).split('') : res.slice(0, (45 - n - textLength)).split('');
        // if ((d.id != rootParentId && res.length > (39 - n - textLength)) || res.length > (45 - n - textLength)) {
        //   finalText.push('...');
        // }
        // return finalText.join('');
        let finalText = res.slice(0, (39 - n - textLength)).split('');
        if (res.length > (39 - n - textLength)) {
          finalText.push('...');
          d.tooltipFooter = true;
        }
        return finalText.join('');
      });

    const ownerText = nodeEnter.append('text')
      .attr('class',d=> (d.deletedStatus ? 'hide' :'ownerText'))
      .attr('x', 14)
      .attr('y', 90)
      .attr('dy', '.45em')
      .attr('text-anchor', 'left');
    ownerText.append('tspan')
      .attr('font-size', 12)
      .attr('fill', 'rgba(0, 0, 0, 0.54)')
      .text(d => d.pending ? 'Owner: ' : '');

    ownerText.append('tspan')
      .attr('font-size', 12)
      .text(d => d.pending ? d.ownerName : '')
      .attr('width', d => (hasGivePing(d) ? _rectW - 90 : _rectW - 50))
      .call(elipse, 200);

    ownerText.append('tspan')
      .attr('class', 'dotclass ping-label-dotclass ')
      .text(d => (hasGivePing(d) ? '  ·  ' : ''))
      .append('tspan')
      .attr('class', 'ping-label')
      .text(d => (hasGivePing(d) ? 'Ping' : ''))
      .on('click', pingMetric);

    const downimages1 = nodeEnter.append('image')
      .attr('xlink:href', function () {
        return wbConfig.baseUrl + '/images/icons/down_blue_arrow.png';
      })
      .attr('x', function () {
        let bbNode = this.parentElement.getBBox();
        return bbNode.width / 2 - ARROW_WIDTH / 2;
      })
      .attr('y', function () {
        let bbNode = this.parentElement.getBBox();
        return bbNode.height + 5;
      })
      .attr('height', d => d._down ? ARROW_HEIGHT : 0)
      .attr('width', d => d._down ? ARROW_WIDTH : 0);
    // make the image grow a little on mouse over and add the text details on click
    const setEvents = downimages1
      // Append hero text
      .on('click', function (d) {
        //toggleNodes(d);
        renderParent(d);
        //  update(_root);
        $(this).attr('height', 0);
        d3.event.stopPropagation();
        height = 500;
        return false;
      });

    const upimages = nodeEnter.append('image')
      .attr('xlink:href', wbConfig.baseUrl + '/images/icons/up_blue_arrow.png')
      .attr('x', function () {
        let bbNode = this.parentElement.getBBox();
        return bbNode.width / 2 - ARROW_WIDTH / 2;
      })
      .attr('y', -(ARROW_HEIGHT + 1))
      .attr('height', d => (d._children && d._children.length ? ARROW_HEIGHT : 0))
      .attr('width', d => (d._children && d._children.length ? ARROW_WIDTH : 0));

    // make the image grow a little on mouse over and add the text details on click
    const setEvents1 = upimages
      // Append hero text
      .on('click', function (d) {
        console.log("image clicked " + d.up);
        $(this).attr('height', 0);
        toggleNodes(d);
        updateTop(d);
        height = 500;
        d3.event.stopPropagation();
        return false;
      });

    let transformHeight;
    if (source) {
      if (source.id == rootParentId && source.children.length) {
        source.children.forEach(firstLevelchild => {

          if (firstLevelchild.children && firstLevelchild.children.length > 0) {
            firstLevelchild.children.forEach(secondLevelChild => {
              timeout = 800;
              let a = 170,
                b;
              if (secondLevelChild._children) {
                timeout = 200;
                secondLevelChild._children.forEach(thirdLevelChild => {
                  b = 0;
                })
              }
              if (b == 0) {
                transformHeight = 0;
              } else {
                transformHeight = a;
              }
            })

          } else {
            transformHeight = 340;
          }

          if (source.children.length == 1) {
            transformHeight = 340;
            if (source.children[0].children && (source.children[0].children.length)) {
              transformHeight = 170;
            }
          }

        });
      } else {
        if (source.depth >= 2) {
          transformHeight = 0;
        }
      }
    }

    // Transition nodes to their new position.
    const nodeUpdate = node.transition()
      .duration(_duration)
      // .attr('transform', d => d.id == rootParentId ? `translate(${d.x-25},${height-transformHeight-d.y})` : `translate(${d.x},${height-transformHeight-d.y})`);
      .attr('transform', d => `translate(${d.x},${height - transformHeight - d.y})`);

    // Transition exiting nodes to the parent's new position.
    const nodeExit = node.exit().transition()
      .duration(_duration)
      .attr('transform', d => `translate(${source.x},${source.y})`)
      .remove();

    // Update the links
    const link = _svg.selectAll('path.link')
      .data(links, d => `${d.target.id}-${d.target.depth}-${d.target.parentId}`);

    // Enter any new links at the parent's previous position.
    link.enter().append('path', 'g')
      .attr('class', 'link')
      .attr('d', (d) => {
        const o = {
          x: source.x0,
          y: source.y0,
        };
        return _diagonal({
          source: o,
          target: o,
        });
      })
      .attr('stroke', d => d.source.id == rootParentId ? boxBorderColor(0) : boxBorderColor(1))
      .style('stroke-width', 1)
      .style('opacity', 1e-6);

    link
      .transition()
      .duration(_duration) // Was _duration * 2, but links should always transition together with the nodes.
      .style('opacity', 1)
      .attr('d', (d) => {
        const u_line = (function (d) {
          const u_linedata = [{
              x: d.source.x + parseInt(_rectW / 2),
              y: height - transformHeight - d.source.y
            },
            {
              x: d.source.x + parseInt(_rectW / 2),
              y: height - d.target.y - transformHeight + _rectH + MARGIN.top / 2
            },
            {
              x: d.target.x + parseInt(_rectW / 2),
              y: height - d.target.y - transformHeight + _rectH + MARGIN.top / 2
            },
            {
              x: d.target.x + parseInt(_rectW / 2),
              y: height - d.target.y - transformHeight + _rectH
            }
          ];
          return u_linedata;
        }(d));

        return _lineFunction(u_line);
      });

    // Transition exiting nodes to the parent's new position.
    link.exit().transition()
      .duration(_duration)
      .style('opacity', 1e-6)
      .attr('d', (d) => {
        /* This is needed to draw the lines right back to the caller */
        const u_line = (function () {
          const u_linedata = [{
              x: _callerNode.x + parseInt(_rectW / 2),
              y: _callerNode.y + _rectH + 2
            },
            {
              x: _callerNode.x + parseInt(_rectW / 2),
              y: _callerNode.y + _rectH + 2
            },
            {
              x: _callerNode.x + parseInt(_rectW / 2),
              y: _callerNode.y + _rectH + 2
            },
            {
              x: _callerNode.x + parseInt(_rectW / 2),
              y: _callerNode.y + _rectH + 2
            }
          ];
          return u_linedata;
        }(d));

        return _lineFunction(u_line);
      })
      .each('end', () => {
        _callerNode = null; /* After transition clear the caller node variable */
      });

    // Stash the old positions for transition.
    _nodes.forEach((d) => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
  }
  return {
    initTree
  };
})();

export default OrgChartViz;